
<div *ngIf="!config.multiCheck">
<div [formGroup]="group" class="chip-control" *ngIf="config.isFormArray">  
    <div for="" class="default-sub-header text-label">{{config.groupLabel | translate}}</div>
    <div [formArrayName]="config.name"  >
    <div *ngFor="let item of configName.controls;let i=index" [formGroup]="item" [ngClass]="config.class">     
      <div *ngFor="let option of config.options">
    <mat-checkbox class="chip-control__checkbox" formControlName="{{option.id}}">
      <span class="default-form-field">{{option.value}}</span></mat-checkbox>     
    </div>
     </div>     
  </div>
</div>

<div [formGroup]="group" class="chip-control {{config.class}}" *ngIf="!config.isFormArray">    
           
  <mat-checkbox class="chip-control__checkbox" [formControlName]="config.name" >
    <span *ngIf="innerHTMLdata" class="default-form-field" [innerHTML]="config.placeholder"></span>
    <span *ngIf="!innerHTMLdata" class="default-form-field" >{{config.placeholder | translate}}</span>
  </mat-checkbox>     
</div>
</div>

<div [formGroup]="group" class="mt-3 chip-control {{config.class}}" *ngIf="config.multiCheck">
  <div for="" class="default-sub-header text-label pb-0">{{config.label | translate}}</div>
<section class="dynamic-section {{config.class}}"  *ngFor="let option of config.options">
  <mat-checkbox class="chip-control__checkbox" [formControlName]="config.name" [(ngModel)]="config.id" >{{option.value}}</mat-checkbox>
</section>
</div>


